import { UsePeerCreditForm } from 'core/Components';
import { UseAdditionalFieldsForm } from 'ui';
import { UseFormReturnType } from 'ui/Form';

const ADDITIONAL_FIELDS_FORM_ID = 'additional_fields_store_item_form';

type StoreItemDetailsFormType = {
  price: number | null;
  quantity: number;
};

type StoreItemOrderForms = {
  store_item_details: UseFormReturnType<StoreItemDetailsFormType>;
  additional_fields_store_item_form?: UseAdditionalFieldsForm;
  peer_credit_form?: UsePeerCreditForm;
};

export { ADDITIONAL_FIELDS_FORM_ID };
export type { StoreItemDetailsFormType, StoreItemOrderForms };
